import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { SECS } from "../common/constants";

export const regexPhoneNumber = (phone: string) => {
  const regexPhoneNumber = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
  return phone.match(regexPhoneNumber) ? true : false;
}

export function convertTimeToString(time: number) {
  const hour = Math.floor(time / (60 * SECS))
    .toString()
    .padStart(2, '0');
  const minute = Math.floor((time / SECS) % 60)
    .toString()
    .padStart(2, '0');
  return hour + ':' + minute;
}

export function formatTime(time?: string, format = "HH:mm"): Dayjs | undefined {
  if (!time) return undefined;
  const t = `${time.slice(0, 2)}:${time.slice(2)}`;
  return dayjs(t, format);
}